"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _CopyTextButton = _interopRequireDefault(require("web/shared/components/CopyTextButton"));
var _useCopyText = _interopRequireDefault(require("web/shared/components/useCopyText"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _hints = require("web/shared/icons/hints");
var _iconGallery = require("web/shared/icons_gallery/iconGallery");
var _styles = require("web/shared/icons_gallery/styles");
var _useLoopingCycles2 = _interopRequireDefault(require("web/shared/icons/useLoopingCycles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* One glyph's card in the internal icon gallery: a big showcase drawing, the
* glyph's name and everyday hints, and the full size-token ramp beneath.
*
* Hovering loops the glyph's progress animation across every size at once, so
* a drawing can be studied rather than glimpsed; a tap anywhere on the card,
* or Enter on its drawing, plays a single cycle, which is the same affordance
* on a device with no pointer. A click anywhere on the card also copies the
* glyph's name, for pasting into an `<Icon name>`, and the copy mark beside
* the name confirms it.
*/
function IconCard(props) {
  // While hovered, the motion loops: whenever the tween catches its target
  // and the pointer is still here, the next whole cycle is queued (so the
  // full animation can be studied); leaving lets the running cycle land at
  // rest on its own. A tap/click also plays one cycle.
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  const _useLoopingCycles = (0, _useLoopingCycles2.default)(isHovered, _iconGallery.CYCLE_DURATION_MS),
    progress = _useLoopingCycles.progress,
    playOnce = _useLoopingCycles.playOnce;
  const copy = (0, _useCopyText.default)(props.name);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    onClick: () => {
      playOnce();
      void copy.genCopy();
    }
  }, stylex.props(_styles.styles.card)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      type: "button",
      "aria-label": "Play ".concat(props.name)
    }, stylex.props(_styles.styles.stage, _styles.styles.stageButton, isHovered && _styles.styles.stageHovered)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        name: props.name,
        size: "xxl",
        progress: progress,
        colors: props.colors
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.nameRow)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.name)), {}, {
        children: props.name
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CopyTextButton.default, {
        text: props.name,
        label: "Copy name",
        copy: copy
      })]
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.hints)), {}, {
      children: _hints.ICON_HINTS[props.name].join(" · ")
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.ramp)), {}, {
      children: _iconGallery.RAMP_SIZES.map(size => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.rampItem)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.rampIcon)), {}, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            name: props.name,
            size: size,
            progress: progress,
            colors: props.colors
          })
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_styles.styles.rampLabel)), {}, {
          children: size
        }))]
      }), size))
    }))]
  }));
}
var _default = exports.default = IconCard;